const communityOrganizationRoutes = [
  {
    path: '',
    name: 'Posts',
    meta: {
      title: {
        en: 'Posts',
        ru: 'Посты',
      },
    },
    component: () => import(/* webpackChunkName: "organization-posts" */ '../components/pages/Posts.vue'),
  },
  {
    path: 'create',
    name: 'CreateBlogPost',
    meta: {
      title: {
        en: 'Create Post',
        ru: 'Создать Пост',
      },
    },
    beforeEnter: async (to, from, next) => {
      const { requiresAuth } = await import('@martyrs/src/modules/auth/views/middlewares/auth.validation.js');
      return requiresAuth(to, from, next);
    },
    component: () => import(/* webpackChunkName: 'CreateBlogPost' */ '../components/pages/CreateBlogPost.vue'),
  },
  {
    path: ':url',
    name: 'BlogPost',
    meta: {
      title: {
        en: 'Post',
        ru: 'Пост',
      },
    },
    component: () => import(/* webpackChunkName: 'BlogPost' */ '../components/pages/BlogPost.vue'),
  },
  {
    path: ':url/edit',
    name: 'EditBlogPost',
    meta: {
      title: {
        en: 'Edit Post',
        ru: 'Редактировать пост',
      },
    },
    beforeEnter: async (to, from, next) => {
      const { requiresAuth } = await import('@martyrs/src/modules/auth/views/middlewares/auth.validation.js');
      return requiresAuth(to, from, next);
    },
    component: () => import(/* webpackChunkName: 'CreateBlogPost' */ '../components/pages/CreateBlogPost.vue'),
  },
];

export default communityOrganizationRoutes;
